var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockWhiteClose = function SvgLockWhiteClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0074 6.77337H11.9496V5.34225C11.9496 2.58033 9.73525 0.333374 7.01332 0.333374C4.2914 0.333374 2.07704 2.58033 2.07704 5.34225V6.77337H1.01926C0.824365 6.77337 0.666656 6.9334 0.666656 7.13116V16.0756C0.666656 16.8649 1.29917 17.5067 2.07704 17.5067H11.9496C12.7275 17.5067 13.36 16.8649 13.36 16.0756V7.13116C13.36 6.9334 13.2023 6.77337 13.0074 6.77337ZM8.06905 14.2472C8.08006 14.3482 8.04806 14.4495 7.98126 14.5254C7.91445 14.6012 7.81872 14.6445 7.71853 14.6445H6.30815C6.20796 14.6445 6.11223 14.6012 6.04542 14.5254C5.97862 14.4496 5.94659 14.3482 5.95763 14.2472L6.18006 12.2176C5.81886 11.951 5.60298 11.5293 5.60298 11.0667C5.60298 10.2774 6.23549 9.63558 7.01336 9.63558C7.79122 9.63558 8.42374 10.2774 8.42374 11.0667C8.42374 11.5293 8.20785 11.951 7.84665 12.2176L8.06905 14.2472ZM9.83405 6.77337H4.19259V5.34225C4.19259 3.76405 5.45799 2.48004 7.01332 2.48004C8.56865 2.48004 9.83405 3.76405 9.83405 5.34225V6.77337Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockWhiteClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock_white_close.77d01e64.svg";
export { ForwardRef as ReactComponent };